module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-box"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-li"
  }, [_c('div', {
    staticClass: "qz-search-wrap"
  }, [_c('van-search', {
    attrs: {
      "placeholder": "搜索",
      "shape": "round"
    },
    on: {
      "search": _vm.onSearch
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [(_vm.checkName) ? _c('div', {
    staticClass: "search-tip",
    attrs: {
      "slot": "left-icon"
    },
    slot: "left-icon"
  }, [_vm._v(_vm._s(_vm.checkName) + " |")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-content-right",
    attrs: {
      "slot": "right-icon"
    },
    on: {
      "click": function($event) {
        return _vm.onSearch(_vm.keywords)
      }
    },
    slot: "right-icon"
  }, [_c('div', {
    staticClass: "search-button flex-center"
  }, [_vm._v("搜索")])])])], 1), _vm._v(" "), (!_vm.defaultSign) ? _c('div', {
    staticClass: "row3"
  }, _vm._l((_vm.columnList), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.num > 0 || !item.sign),
        expression: "item.num > 0 || !item.sign"
      }],
      key: index,
      class: _vm.checkSign == item.sign ? 'row3-li row3-li-active' : 'row3-li',
      on: {
        "click": function($event) {
          return _vm.onChecked(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require('../../../assets/images/cha/' + item.icon + '.png')
      }
    }), _vm._v(" "), _c('div', {
      class: item.sign ? 'row-tip' : 'row-tip row-tips'
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "row-num"
    }, [_vm._v("(" + _vm._s(item.num) + ")")])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.checkSign) ? _c('div', {
    staticClass: "search-result"
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return (_vm.checkSign == 'sai') ? _c('div', {
      key: index,
      staticClass: "sai-itmes sai-box"
    }, [_c('div', {
      staticClass: "items-top1"
    }, [_c('div', {
      staticClass: "train-items-top show-two-row",
      style: ('background-image: linear-gradient(to right, #' + item.color[0] + ' , #' + item.color[1] + ');')
    }, [(item.is_online == 1) ? _c('div', {
      staticClass: "sai-type-tip"
    }, [_vm._v("线上")]) : _c('div', {
      staticClass: "sai-type-tip offline"
    }, [_vm._v("线下")]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-city"
    }, [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('div', {
      staticClass: "train-items-top-time"
    }, [_vm._v(_vm._s(item.saidate_str) + " ~ " + _vm._s(item.saidate_end_str))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-top": ".1rem"
      }
    }, [(item.status == 1) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("未开始")]) : (item.status == 2) ? _c('span', {
      staticClass: "info-status-1"
    }, [_vm._v("正在报名")]) : (item.status == 3) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("报名结束")]) : (item.status == 4) ? _c('span', {
      staticClass: "info-status-1"
    }, [_vm._v("正在比赛")]) : (item.status == 5) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("已结束")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "sai-info-box",
      staticStyle: {
        "flex": "1"
      }
    }, [_c('p', {
      staticClass: "sai-title show-two-row"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (false) ? _c('div', {
      staticClass: "sai-info"
    }, [(item.status == 1) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("·未开始")]) : (item.status == 2) ? _c('span', {
      staticClass: "info-status-1"
    }, [_vm._v("·正在报名")]) : (item.status == 3) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("·报名结束")]) : (item.status == 4) ? _c('span', {
      staticClass: "info-status-1"
    }, [_vm._v("·正在比赛")]) : (item.status == 5) ? _c('span', {
      staticClass: "info-status-0"
    }, [_vm._v("·已结束")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "sai-info"
    }), _vm._v(" "), _c('div', {
      staticClass: "items-btn"
    }, [(item.status < 3) ? _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'ISaiApplyFormStep1',
          query: {
            saiqu_id: item.id
          }
        }),
        expression: "{name:'ISaiApplyFormStep1',query:{saiqu_id:item.id}}"
      }],
      staticClass: "sai-join"
    }, [_vm._v("报名\n            ")]) : _vm._e(), _vm._v(" "), (item.status != 1) ? _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'ActivityActivity',
          query: {
            id: item.activity_id
          }
        }),
        expression: "{name:'ActivityActivity',query:{id:item.activity_id}}"
      }],
      staticClass: "sai-into"
    }, [_vm._v("进入\n            ")]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), (_vm.checkSign == 'news' || _vm.checkSign == 'jwjl') ? _c('div', {
    staticClass: "new-box"
  }, _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:row.id }}"
      }],
      key: i
    }, [(row.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": row
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.checkSign == 'hyjy') ? _c('div', {
    staticClass: "member-box"
  }, _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:row.id }}"
      }],
      key: i,
      staticClass: "right-li flex-start"
    }, [_c('div', {
      staticClass: "right-li-img"
    }, [_c('img', {
      attrs: {
        "src": row.pic_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-li-user"
    }, [_c('div', {
      staticClass: "right-user-one"
    }, [_c('div', {
      staticClass: "right-user-label"
    }, [_vm._v("标题")]), _vm._v(" "), _c('div', {
      staticClass: "right-user-value"
    }, [_vm._v(_vm._s(row.title))])]), _vm._v(" "), _c('div', {
      staticClass: "right-user-one"
    }, [_c('div', {
      staticClass: "right-user-label"
    }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
      staticClass: "right-user-value"
    }, [_vm._v(_vm._s(row.desc))])])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.checkSign == 'goods') ? _c('div', {
    staticClass: "main-bottom-box"
  }, _vm._l((_vm.list), function(goods, index) {
    return _c('goodsItem', {
      attrs: {
        "row": goods
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.checkSign == 'huiyi' || _vm.checkSign == 'qcxj') ? _c('div', {
    staticClass: "main-bottom-box"
  }, _vm._l((_vm.list), function(huiyi, index) {
    return _c('peiItem', {
      attrs: {
        "row": huiyi
      }
    })
  }), 1) : _vm._e()], 2)], 1) : _c('div', {
    staticClass: "search-result"
  }, _vm._l((_vm.list), function(group) {
    return _c('div', {
      key: group.sign,
      staticClass: "search-group-li"
    }, [(group.list.length > 0) ? _c('div', {
      staticClass: "search-group-title"
    }, [_vm._v(_vm._s(group.name))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "search-group-content"
    }, [_vm._l((group.list), function(item) {
      return (group.sign == 'sai') ? _c('div', {
        staticClass: "sai-itmes sai-box"
      }, [_c('div', {
        staticClass: "items-top1"
      }, [_c('div', {
        staticClass: "train-items-top show-two-row",
        style: ('background-image: linear-gradient(to right, #' + item.color[0] + ' , #' + item.color[1] + ');')
      }, [(item.is_online == 1) ? _c('div', {
        staticClass: "sai-type-tip"
      }, [_vm._v("线上")]) : _c('div', {
        staticClass: "sai-type-tip offline"
      }, [_vm._v("线下")]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-city"
      }, [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('div', {
        staticClass: "train-items-top-time"
      }, [_vm._v(_vm._s(item.saidate_str) + " ~ " + _vm._s(item.saidate_end_str))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "text-align": "center",
          "margin-top": ".1rem"
        }
      }, [(item.status == 1) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("未开始")]) : (item.status == 2) ? _c('span', {
        staticClass: "info-status-1"
      }, [_vm._v("正在报名")]) : (item.status == 3) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("报名结束")]) : (item.status == 4) ? _c('span', {
        staticClass: "info-status-1"
      }, [_vm._v("正在比赛")]) : (item.status == 5) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("已结束")]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "sai-info-box",
        staticStyle: {
          "flex": "1"
        }
      }, [_c('p', {
        staticClass: "sai-title show-two-row"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (false) ? _c('div', {
        staticClass: "sai-info"
      }, [(item.status == 1) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("·未开始")]) : (item.status == 2) ? _c('span', {
        staticClass: "info-status-1"
      }, [_vm._v("·正在报名")]) : (item.status == 3) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("·报名结束")]) : (item.status == 4) ? _c('span', {
        staticClass: "info-status-1"
      }, [_vm._v("·正在比赛")]) : (item.status == 5) ? _c('span', {
        staticClass: "info-status-0"
      }, [_vm._v("·已结束")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "sai-info"
      }), _vm._v(" "), _c('div', {
        staticClass: "items-btn"
      }, [(item.status < 3) ? _c('div', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'ISaiApplyFormStep1',
            query: {
              saiqu_id: item.id
            }
          }),
          expression: "{name:'ISaiApplyFormStep1',query:{saiqu_id:item.id}}"
        }],
        staticClass: "sai-join"
      }, [_vm._v("报名\n                ")]) : _vm._e(), _vm._v(" "), (item.status != 1) ? _c('div', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'ActivityActivity',
            query: {
              id: item.activity_id
            }
          }),
          expression: "{name:'ActivityActivity',query:{id:item.activity_id}}"
        }],
        staticClass: "sai-into"
      }, [_vm._v("进入\n                ")]) : _vm._e()])])]) : _vm._e()
    }), _vm._v(" "), (group.sign == 'news' || group.sign == 'jwjl') ? _c('div', {
      staticClass: "new-box"
    }, _vm._l((group.list), function(row, i) {
      return _c('div', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'NewsDetail',
            query: {
              id: row.id
            }
          }),
          expression: "{name:'NewsDetail',query:{id:row.id }}"
        }],
        key: i
      }, [(row.pics.length == 0) ? _c('NewsItem1', {
        attrs: {
          "row": row
        }
      }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
        attrs: {
          "row": row
        }
      }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
        attrs: {
          "row": row
        }
      }) : _vm._e()], 1)
    }), 0) : _vm._e(), _vm._v(" "), (group.sign == 'hyjy') ? _c('div', {
      staticClass: "member-box"
    }, _vm._l((group.list), function(row, i) {
      return _c('div', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'NewsDetail',
            query: {
              id: row.id
            }
          }),
          expression: "{name:'NewsDetail',query:{id:row.id }}"
        }],
        key: i,
        staticClass: "right-li flex-start"
      }, [_c('div', {
        staticClass: "right-li-img"
      }, [_c('img', {
        attrs: {
          "src": row.pic_url,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "right-li-user"
      }, [_c('div', {
        staticClass: "right-user-one"
      }, [_c('div', {
        staticClass: "right-user-label"
      }, [_vm._v("标题")]), _vm._v(" "), _c('div', {
        staticClass: "right-user-value"
      }, [_vm._v(_vm._s(row.title))])]), _vm._v(" "), _c('div', {
        staticClass: "right-user-one"
      }, [_c('div', {
        staticClass: "right-user-label"
      }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
        staticClass: "right-user-value"
      }, [_vm._v(_vm._s(row.desc))])])])])
    }), 0) : _vm._e(), _vm._v(" "), (group.sign == 'goods') ? _c('div', {
      staticClass: "main-bottom-box"
    }, _vm._l((group.list), function(goods, index) {
      return _c('goodsItem', {
        attrs: {
          "row": goods
        }
      })
    }), 1) : _vm._e(), _vm._v(" "), (group.sign == 'huiyi' || group.sign == 'qcxj') ? _c('div', {
      staticClass: "main-bottom-box"
    }, _vm._l((group.list), function(huiyi, index) {
      return _c('peiItem', {
        attrs: {
          "row": huiyi
        }
      })
    }), 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.list.length > 0),
        expression: "group.list.length>0"
      }],
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('van-button', {
      attrs: {
        "size": "normal",
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.onChecked(group)
        }
      }
    }, [_vm._v("查看更多有关[" + _vm._s(_vm.keywords) + "]的" + _vm._s(group.name))])], 1)])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d2766d3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cha/SearchAllResult.vue
// module id = 2377
// module chunks = 0